export const UNAVAILABLE_REQUIRED_USER_ERROR_MESSAGE = "Attempted to access unavailable required authenticated user";
